import { createFileRoute } from '@tanstack/react-router'
import { Preparo } from '@/features/preparo/Preparo'

/** Preparação da sessão. Aba das páginas da sessão; a chave fica no layout. */
export const Route = createFileRoute('/_app/app/s/$id_/_sessao/preparo')({
  component: function PreparoDaSessao() {
    const { id } = Route.useParams()
    return <Preparo key={id} sessionId={id} />
  },
})
